import React, { useState, useRef, useEffect } from 'react';
import './OwnerRegistration.css';
import PropertImage from '../../Images/Property.png';
import { RxDotsVertical } from 'react-icons/rx'; // Import the dots icon
import SelectPricingPlan from '../Settings/SelectPricingPlan';

const OwnerRegistartionCard = ({ ownerName, property, entityName, email, mobilePhone, entityAddress, handleDelete, handleEdit, handleSelectedowner, handleRegsiterOwner, handleManageTeamMembers, entityId, onActiveMenuIdChange, activeMenuId, b2cidowner, tandC, isEmailPhoneVerified, isTempPassword }) => {
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  // console.log("ownerb2cIdownerb2cIdownerb2cIdownerb2cIdownerb2cId",property.userId);
  const [isSelectPricingOpen, setIsSelectPricingOpen] = useState(false);
   

  const dotsRef = useRef(null);
  const menuRef = useRef(null);
  const showMenu = activeMenuId === entityId;
  // Toggle menu visibility
  const handleDotsClick = (event) => {
    event.stopPropagation(); // Prevents triggering handleSelectedowner
    if (dotsRef.current) {
      const { top, left, height } = dotsRef.current.getBoundingClientRect();
      const parentCard = dotsRef.current.closest('.property-card');
      const parentCardRect = parentCard.getBoundingClientRect();

      setMenuPosition({
        top: top - parentCardRect.top + height,
        left: left - parentCardRect.left - 150,
      });
      onActiveMenuIdChange(showMenu ? null : entityId);

    } 
  };

  const handleSelectPricingPlan = (event) => {
        event.stopPropagation();
        setIsSelectPricingOpen(true);
    }
  const handleCancelSelectPricing = (event) => {
        event.stopPropagation();
        setIsSelectPricingOpen(false);
    }


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target) && !menuRef.current.contains(event.target)) {
        onActiveMenuIdChange(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div className="property-card" onClick={handleSelectedowner} style={{ position: 'relative' }} >
      <div className="property-content">
        <div className="owner-details">
          <img src={PropertImage} alt="Owner" className="owner-icon" />
          <div className="info-block">
            {property.userId ? <strong>Registered</strong> : <strong>Unregistered</strong>}
          </div>
        </div>
        <div className="property-info">
          <div className="info-block">
            <p className="info-header">Owner Name</p>
            <p className="info-data">{ownerName}</p>
          </div>
          <div className="info-block">
            <p className="info-header">Entity Name</p>
            <p className="info-data">{entityName}</p>
          </div>
          <div className="info-block">
            <p className="info-header">Email</p>
            <p className="info-data">{email}</p>
          </div>
          <div className="info-block">
            <p className="info-header">Mobile Phone</p>
            <p className="info-data">{mobilePhone}</p>
          </div>
          <div className="info-block">
            <p className="info-header">Entity Address</p>
            <p className="info-data" title={entityAddress}>{entityAddress?.length > 40 ? `${entityAddress.slice(0, 20)}...` : entityAddress}</p>
          </div>
        </div>
        <div className="dots-menu" onClick={handleDotsClick} style={{ cursor: 'pointer' }} ref={dotsRef}>
          <RxDotsVertical size={28} />
        </div>
        {showMenu && (
          <div className="dropdown-menu1"
            ref={menuRef}
            style={{
              position: 'absolute',
              top: `${menuPosition.top}px`,
              left: `${menuPosition.left}px`,
            }}>
            <div className="dropdown-option" onClick={(e) => handleRegsiterOwner(e, true, email, entityId, property.userId)}>Edit Details</div>
            <div className="dropdown-option" onClick={(e) => handleEdit(e, property)}>Add Property</div>
            {handleManageTeamMembers && property?.userId && (
              <div className="dropdown-option" onClick={(e) => handleManageTeamMembers(e, property)}>Manage Team Members</div>
            )}
            <div className="dropdown-option" onClick={(e) => handleDelete(e, property)}>Delete Owner</div>
            {/* <div className="dropdown-option" onClick={(e) => handleSelectPricingPlan(e)}>Pricing Plan</div> */}
            {isSelectPricingOpen &&
                <div className="popup-overlay" onClick={(e) => {
                                            e.stopPropagation(); // prevent card click
                                            //handleCancelSelectPricing(e); // close popup
                                          }}>
                    <div className="popup-content">
                        <SelectPricingPlan setIsSelectPricingOpen={setIsSelectPricingOpen}
                         handleCancelSelectPricing={handleCancelSelectPricing} entityId={entityId}/>
                    </div>
                </div>
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default OwnerRegistartionCard;
